import axios from "axios";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { supportedLanguage } from "./constant/constant";

const getJSON = async (url) => {
  const res = await axios.get(url);
  return res?.data;
};

const getResources = async () => {
  let languages = {};
  for (const lang of supportedLanguage) {
    const URL = import.meta.env.DEV ? `/locales/${lang}/translation.json` : `/scai/locales/${lang}/translation.json`;
    try {
      languages[lang] = {
        translation: await getJSON(URL),
      };
    } catch (e) {
      console.log(`Error loading translation file ${lang}`);
    }
  };
  return languages;
};

export const i18nReady = (async () => {
  const resources = await getResources();
  const settings = JSON.parse(localStorage.getItem("settings") || "{}");
  const savedLang = settings?.platform?.language || "en-US";
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)

    .init({
      fallbackLng: savedLang,
      detection: {
        order: ["localStorage", "cookie", "querystring"],
        caches: ["localStorage"],
      },
      interpolation: {
        escapeValue: false,
      },
      react: {
        bindI18n: "languageChanged loaded",
        bindI18nStore: "added loaded",
        transEmptyNodeValue: "",
        transSupportBasicHtmlNodes: "",
        transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
        useSuspense: true,
      },
      resources
    });
})();

export default i18n;
